import { useState } from "react";
import { Info } from "lucide-react";
import { Button } from "../client/components/ui/button";
import useTranslation from "../client/hooks/useTranslation";
import { WalletInitialBalanceModal } from "./WalletInitialBalanceModal";

const BANNER_KEY = "tpt_wallet_initial_balance_banner_dismissed";

interface WalletInitialBalanceBannerProps {
  propFirmTemplateId: string;
  onMutated: () => void;
}

export function WalletInitialBalanceBanner({
  propFirmTemplateId,
  onMutated,
}: WalletInitialBalanceBannerProps) {
  const t = useTranslation();
  const w = t.propFirmManager.wallet;
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(BANNER_KEY) === "true"
  );
  const [showModal, setShowModal] = useState(false);

  if (dismissed) return null;

  const dismiss = () => {
    localStorage.setItem(BANNER_KEY, "true");
    setDismissed(true);
  };

  return (
    <>
      <div className="flex items-start gap-3 rounded-lg border border-primary/30 bg-primary/10 px-4 py-3">
        <Info className="h-4 w-4 text-primary mt-0.5 shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">{w.initialBalanceBannerTitle}</p>
          <p className="text-xs text-muted-foreground mt-0.5">
            {w.initialBalanceBannerDesc}
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <Button
            size="sm"
            variant="outline"
            onClick={dismiss}
            className="h-7 text-xs"
          >
            {w.ignore}
          </Button>
          <Button
            size="sm"
            onClick={() => setShowModal(true)}
            className="h-7 text-xs"
          >
            {w.setInitialBalance}
          </Button>
        </div>
      </div>
      <WalletInitialBalanceModal
        open={showModal}
        onClose={() => setShowModal(false)}
        propFirmTemplateId={propFirmTemplateId}
        onMutated={() => {
          onMutated();
          dismiss();
        }}
      />
    </>
  );
}
